import React from 'react';
import { InfoWindow } from '@react-google-maps/api';

const AlcoholZoneInfoWindow = ({ place, placeType, position, onClose }) => {
  if (!place) return null;

  const isSchool = placeType === 'school';
  const bufferYards = isSchool ? 200 : 100;
  const icon = isSchool ? '🏫' : '⛪';
  const severityColor = isSchool ? '#dc2626' : '#f97316';
  const severityLabel = isSchool ? 'CRITICAL' : 'HIGH';

  return (
    <InfoWindow position={position} onCloseClick={onClose}>
      <div style={{ minWidth: 220, fontFamily: 'system-ui, sans-serif', color: '#1f2937' }}>
        <h4 style={{ margin: '0 0 8px', fontSize: 14, fontWeight: 700, borderBottom: `2px solid ${severityColor}`, paddingBottom: 6 }}>
          {icon} {place.name || `Unknown ${placeType}`}
        </h4>
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div><b>Type:</b> {isSchool ? 'School' : 'Church'}</div>
          <div><b>Buffer Zone:</b> {bufferYards} yards</div>
          <div>
            <b>Distance:</b>{' '}
            {place.distance_meters != null
              ? `${Math.round(place.distance_meters)} m (${Math.round(place.distance_meters * 1.09361)} yards)`
              : 'N/A'}
          </div>
          <div style={{
            marginTop: 8,
            padding: '6px 10px',
            background: isSchool ? '#fef2f2' : '#fff7ed',
            border: `1px solid ${severityColor}`,
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 600,
            color: severityColor,
          }}>
            ⚠️ Alcohol Permit Restriction Zone — Severity: {severityLabel}
          </div>
        </div>
      </div>
    </InfoWindow>
  );
};

export default AlcoholZoneInfoWindow;
